import { BacKNavArea } from "../component/Signup/style";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import ArrowbackIcon from "../useIconpark/ArrowBack";

interface BackLinkProps {
  path: string;
}
const BackLink = ({ path }: BackLinkProps) => {
  const navigate = useNavigate();

  const handleback = () => {
    setTimeout(() => {
      navigate(path);
    }, 1000);
  };

  return (
    <>
      <BacKNavArea>
        <Arrowback onClick={handleback}>
          <ArrowbackIcon trigger="click" size={25} />
        </Arrowback>
      </BacKNavArea>
    </>
  );
};

export default BackLink;

const Arrowback = styled.div`
  width: auto;
  height: auto;
  padding: 10px;
  cursor: pointer;
`;
